<template>
  <div
    class="h-9 items-center self-end rounded-lg bg-gray-100 p-1"
    data-cy="schedule-view-toggle"
    role="group"
    aria-label="Schedule view"
  >
    <button
      type="button"
      class="view-toggle-btn h-7 rounded-md px-4 text-sm font-medium"
      :class="
        !isWeekView
          ? 'active bg-white text-gray-900 shadow-sm'
          : 'text-gray-500 hover:text-gray-900'
      "
      data-cy="schedule-view-day"
      @click="handleViewChange('day')"
    >
      Day
    </button>
    <button
      type="button"
      class="view-toggle-btn h-7 rounded-md px-4 text-sm font-medium"
      :class="
        isWeekView
          ? 'active bg-white text-gray-900 shadow-sm'
          : 'text-gray-500 hover:text-gray-900'
      "
      data-cy="schedule-view-week"
      @click="handleViewChange('week')"
    >
      Week
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { updateQueryParam } from "@/lib/url.js";

type BoardView = "day" | "week";

const store = useStore();

const isWeekView = computed<boolean>(
  () => store.getters.scheduleWeekViewActive
);
const boardView = computed<BoardView>(
  () => store.state.scheduleBoardFilters.view || "day"
);

function handleViewChange(view: BoardView) {
  if (view === boardView.value) return;
  // Single query write per interaction: router-driven updateQueryParam
  // calls race each other and drop params when issued back to back.
  updateQueryParam("view", view, true);
  store.dispatch("setScheduleBoardFilters", { view });
}
</script>

<style lang="scss" scoped>
.view-toggle-btn {
  border: none;
  background: transparent;
  cursor: pointer;
  transition: background-color 120ms ease, color 120ms ease,
    box-shadow 120ms ease;
}

@media (prefers-reduced-motion: reduce) {
  .view-toggle-btn {
    transition: none;
  }
}
</style>
